export const formatDate = (date: Date) => {
	const dia = String(date.getDate()).padStart(2, '0');
	const mes = String(date.getMonth() + 1).padStart(2, '0');
	const ano = date.getFullYear();

	return `${ano}-${mes}-${dia}`;
};

export const formatDateFromSlashToDash = (dateString: string) => {
	const [dia, mes, ano] = dateString
		.split('/')
		.map((it) => it.padStart(2, '0'));

	return `${ano}-${mes}-${dia}`;
};

export function civilYmd(value: Date | string | null | undefined): {
	year: number;
	month: number;
	day: number;
} {
	if (value == null || value === '') {
		return { year: Number.NaN, month: Number.NaN, day: Number.NaN };
	}
	if (typeof value === 'string') {
		const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (iso) {
			return { year: Number(iso[1]), month: Number(iso[2]), day: Number(iso[3]) };
		}
		value = new Date(value);
	}
	if (Number.isNaN(value.getTime())) {
		return { year: Number.NaN, month: Number.NaN, day: Number.NaN };
	}
	if (
		value.getUTCHours() === 0 &&
		value.getUTCMinutes() === 0 &&
		value.getUTCSeconds() === 0 &&
		value.getUTCMilliseconds() === 0
	) {
		return {
			year: value.getUTCFullYear(),
			month: value.getUTCMonth() + 1,
			day: value.getUTCDate(),
		};
	}
	return {
		year: value.getFullYear(),
		month: value.getMonth() + 1,
		day: value.getDate(),
	};
}

export function civilDate(value: Date | string | null | undefined): Date {
	const { year, month, day } = civilYmd(value);
	return new Date(year, month - 1, day);
}

export function addInclusiveCalendarDays(
	start: Date | string | null | undefined,
	totalDays: number,
): Date {
	const { year, month, day } = civilYmd(start);
	return new Date(year, month - 1, day + (totalDays - 1));
}

export const dateInUTCFormat = (dateString: string) => civilDate(dateString);

export function removeTimeZone(date: Date) {
	return new Date(date.toISOString().split('T')[0] + 'T00:00:00');
}

export function removeTimeZoneWithoutTimezone(dateString: string): string {
	const date = new Date(dateString);
	const userTimezoneOffset = date.getTimezoneOffset() * 60000;
	const correctedDate = new Date(date.getTime() - userTimezoneOffset);
	return correctedDate.toISOString().split('T')[0];
}

export function removeTimeZoneFromString(date: string) {
	if (!date) return '';

	return date.split('T')[0];
}

export const isYear2099 = (date: Date) => date.getFullYear() === 2099;

export function formatddMMyyyy(dateString: string): string {
	const date = new Date(dateString);

	const year = date.getUTCFullYear();
	const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
	const day = date.getUTCDate().toString().padStart(2, '0');

	return `${day}/${month}/${year}`;
}
